export default __webpack_public_path__ + "static/media/hht1_ep02_book_wp_02.fd5e5b6a.jpg";